<template lang="pug">
v-navigation-drawer.nav(
  right,
  absolute="1",
  width="400",
  :value="opened",
  @input="$emit('close', $event)"
)
  .ma-4
    .mb-4
      v-btn.mr-2(text, @click="$emit('close', false)") close
      v-menu(
        offset-x,
        :nudge-width="400",
        :close-on-content-click="false",
        v-model="menu"
      )
        template(v-slot:activator="{ on, attrs }")
          v-btn(dark, color="primary", v-on="on", v-bind="attrs") add
        v-card
          v-card-title Add note
          v-card-text
            v-textarea(label="Enter text", v-model="noteText")
          v-card-actions
            v-spacer
            v-btn(text, @click="menu = false") cancel
            v-btn(text, color="primary", @click="addNote") add

    v-card.mb-4(v-for="(note, i) in notes", :key="i", color="yellow lighten-3")
      v-card-title {{ note.user.first_name }} {{ note.user.last_name }}
      v-card-subtitle {{ formatDate(note.UpdatedAt) }}
      v-card-text {{ note.message }}
</template>

<script>
import { format, parseISO } from "date-fns";

export default {
  props: ["opened", "notes"],

  data: () => ({
    menu: false,
    noteText: "",
  }),

  methods: {
    formatDate(val) {
      return format(parseISO(val), "dd MMM yyyy");
    },

    addNote() {
      this.$emit("addNote", this.noteText);
      this.noteText = "";
      this.menu = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.nav
  z-index: 100
</style>